// Billing dates are calendar days; converting their UTC timestamp shifts the
// label to the previous day in Colombia and other time zones west of UTC.
export function subscriptionBillingDate(value) {
  if (!value) return null;
  const day = String(value).slice(0, 10);
  if (!/^\d{4}-\d{2}-\d{2}$/.test(day)) return null;
  const date = new Date(`${day}T00:00:00`);
  return Number.isNaN(date.getTime()) ? null : date;
}
